import { Component } from '@angular/core';
import { NavController, NavParams, AlertController } from 'ionic-angular';
import { Globals } from '../../providers/globals';

import { QrCodeHandler } from '../../providers/qrcode-handler'

@Component({
  selector: 'page-business-site-qr',
  templateUrl: 'business-site-qr.html',
})
export class BusinessSiteQrPage {
	qrCodeUrl: any;
  isLoading: boolean = false;

  constructor(
  	public navCtrl: NavController, 
  	public navParams: NavParams,
    public alertCtrl: AlertController,
    public qrCodeHandler: QrCodeHandler,
    public globals: Globals) {
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad BusinessSiteQrPage');

    var data = { url: this.globals.pwaUrl}

    this.isLoading = true;

    this.qrCodeHandler.createQrCode(data, (guid)=>{
      this.qrCodeUrl =  this.globals.dataUrl + "qrcode/guid/" + guid
      
      setTimeout(()=>{
        this.isLoading =false;
      }, 1000)    
    });     
  }
}



// WEBPACK FOOTER //
// ./src/pages/business-site-qr/business-site-qr.ts